import setFaq from './pages/setFaq';
import setAbas from './pages/setAbas';

import Swiper from 'swiper';
import { Navigation, Pagination, Zoom, Thumbs } from 'swiper/modules';

Swiper.use([Navigation, Pagination, Zoom, Thumbs]);

//addImports

const Page = {
  handleProjectsTabs: function () {
    const contentTermsUse = document.querySelector('.content-projects');

    if(contentTermsUse){
      const tabs = contentTermsUse.querySelectorAll('.tab');
      const tabsContentSection = contentTermsUse.querySelectorAll('.tab-content');
  
      if (!tabs || !tabsContentSection) return;
  
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const tabId = tab.getAttribute('data-tab');
  
          tabsContentSection.forEach((content) => {
            content.classList.remove('active');
          });
  
          tabs.forEach((tab) => {
            tab.classList.remove('active');
          });
  
          tab.classList.add('active');
  
          const selectedContent = document.getElementById(tabId);
  
          selectedContent.classList.add('active');
        });
      });
    }
  },

  setSwiperReview: function () {
    const reviews = document.querySelectorAll('[data-page-review]');

    if(reviews.length > 0) reviews.forEach(swiper => {
      const prevEl = swiper.querySelector('.swiper-button-prev');
      const nextEl = swiper.querySelector('.swiper-button-next');


      new Swiper(swiper, {
        slidesPerView: 2,
        slidesPerGroup: 1,
        spaceBetween: 10,
        preloadImages: false,
        speed: 1000,
        lazy: {
          checkInView: true,
          loadPrevNext: true,
          loadOnTransitionStart: true,
          loadPrevNextAmount: 4,
        },
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
          },
          992: {
            slidesPerView: 4,
          },
        },
      });
    });
  },

  init: function () {
    var _this = this;
    if (document.querySelector('[data-tab]')) setAbas();
    setFaq();

    //calls
    this.handleProjectsTabs();
    this.setSwiperReview();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Page.init();
});
